module.exports = __webpack_public_path__ + "static/media/head-side.1d56739e.svg";